import BaseViewController from "./base-view-controller";
import { REPLY_BUTTON } from "../utils/constants";

class MessageCenterDetailViewController extends BaseViewController {
  handleButtonClick(name, text, action) {
    const actionBtn = { ...action };

    if (
      name === REPLY_BUTTON.name &&
      action.value === REPLY_BUTTON.action.value
    ) {
      actionBtn.type = REPLY_BUTTON.action.typeOverride;
    }

    super.handleButtonClick(name, text, actionBtn);
  }
}

export default MessageCenterDetailViewController;
